const tables = [
  {
    name: "Number",
  },
  {
    name: "Customer",
  },
  {
    name: "Project",
  },
  {
    name: "Date",
  },
  {
    name: "Due",
  },
  {
    name: "Status",
  },
  {
    name: "Total",
  },
  {
    name: "Action",
  },
];

export default tables;
